export default {
  slots: {
    identity: {
      label: 'ID-document',
      hint: "Identiteitskaart, paspoort of verblijfsvergunning, voor- en achterzijde. Ook ID's van partners horen hier thuis.",
    },
    trade_registration: {
      label: 'Bedrijfsregistratie (Gewerbeanmeldung)',
      hint: 'De bedrijfsregistratie die je van de Kamer van Koophandel hebt ontvangen.',
    },
    commercial_register_extract: {
      label: 'Uittreksel handelsregister (Handelsregisterauszug)',
      hint: 'Een actueel uittreksel uit het handelsregister, als je bedrijf daar geregistreerd is.',
    },
    bank_statement: {
      label: 'Bankafschrift (Kontoauszug)',
      hint: 'Een recent afschrift van je zakelijke rekening waarop de rekeninghouder en het IBAN te zien zijn.',
    },
    shareholder_list: {
      label: 'Lijst van aandeelhouders (Gesellschafterliste)',
      hint: 'De actuele lijst van aandeelhouders.',
      hint_gbr: 'Je samenwerkingsovereenkomst (Gesellschaftsvertrag) of een lijst van alle partners.',
    },
    tax_number: {
      label: 'Btw-nummer of btw-ID (Steuernummer oder USt-IdNr.)',
      hint: 'Een brief van de belastingdienst met je btw-nummer, of de bevestiging van je btw-ID.',
    },
  },
  tags: {
    required: 'Verplicht',
    optional: 'Optioneel',
    missing: 'Ontbreekt',
  },
  kinds: {
    passport: 'Paspoort',
    driver_license: 'Rijbewijs',
    id_card: 'Identiteitskaart',
    residence_permit: 'Verblijfsvergunning',
  },
  holders: {
    owner: 'Eigenaar',
    partner: 'Partner: {{name}}',
  },
  file: {
    with_back: 'Voor- en achterzijde',
    uploaded_at: 'Geüpload op {{date}}',
    expires_at: 'Geldig tot {{date}}',
  },
  errors: {
    load: 'De documenten konden niet worden geladen.',
  },
  empty: 'Nog geen bestand',
  buttons: {
    add: 'Bestand toevoegen',
    replace: 'Vervangen',
    remove: 'Verwijderen',
    retry: 'Opnieuw proberen',
  },
  remove_confirm: {
    title: 'Dit bestand verwijderen?',
    description: 'Gebruik dit voor een bestand dat je per ongeluk hebt geüpload.',
    ok: 'Verwijderen',
    cancel: 'Annuleren',
  },
  toasts: {
    remove_success: 'Bestand verwijderd',
    remove_error: 'Het bestand kon niet worden verwijderd. Probeer het opnieuw.',
  },
};
